module.exports = __webpack_public_path__ + "img/day-rain.0477ede7.svg";